import { styled } from 'linaria/react';

export const FormStyled = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
  width: 60%;

  @media (--only-mobile) {
    gap: var(--space-300);
    width: 100%;
  }
`;

export const Container = styled.div`
  display: flex;
  gap: 11%;
  width: 100%;
  padding: var(--space-300) var(--space-400) var(--space-200) var(--space-400);

  @media (--only-mobile) {
    padding: var(--space-200);
  }
`;

export const SkeletonContainer = styled.div`
  width: 29%;
  height: 226px;
  padding-top: var(--space-475);

  @media (--only-mobile) {
    width: 100%;
  }
`;
